import denvoraLogo from "@/assets/denvora-mobility-logo.png";
import { PRODUCT_BRAND } from "@/config/platform";

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-background flex items-center justify-center z-50">
      <div className="text-center">
        <img 
          src={denvoraLogo} 
          alt={PRODUCT_BRAND}
          width={200}
          height={120}
          className="h-24 w-auto mx-auto animate-pulse object-contain"
        />
        <div className="mt-6 flex justify-center gap-1">
          <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
